import styled from 'styled-components';

const LogEntryTitleContainer = styled.div`
  display: flex;
  width: 100%;
`;

export default LogEntryTitleContainer;
